import React from 'react';

import { generateCardProps } from '../../utils/subscriptionCardOptions';
import { CorporateSubscriptionCard, SubscriptionOptionCard } from '../shared';
import styles from './styles.module.css';

const OptionsSection = () => {
  return (
    <div className={styles.subOptionsSection}>
      <div className={styles.subOptionsContainer}>
        <h6 className={styles.sectionHeader}>More Subscription Options</h6>
        <div className={styles.cardSection} data-test="card-section">
          {[
            generateCardProps({ planType: 'basic' }),
            generateCardProps({ planType: 'all_access' }),
            generateCardProps({ planType: 'young_professionals' }),
          ].map((cardProps) => (
            <SubscriptionOptionCard
              key={cardProps.title}
              customStyles={styles.optionCard}
              {...cardProps}
            />
          ))}
          <CorporateSubscriptionCard />
        </div>
      </div>
    </div>
  );
};

export default OptionsSection;
